export default __webpack_public_path__ + "static/media/iphone-12-pro-max.c63e7196.png";